import React from 'react';
import CreativePreview from './CreativePreview';
import ValueChangeBlock from './ValueChangeBlock';
import { getIntentTone } from './intentTone';

export default function BeforeAfter({
  entity,
  subtitle,
  valueChange,
  actionLabel,
  intent,
  afterEditable = false,
  valueAfterRaw,
  onChangeValueAfterRaw,
  afterLabel,
}) {
  const tone = getIntentTone(intent);

  return (
    <div className="mb-5 rounded-2xl overflow-hidden border border-white/10 bg-white/5">
      <div className="px-4 py-3 flex items-center gap-4">
        <div className="min-w-0 flex-1">
          <CreativePreview entity={entity} subtitle={subtitle} size="lg" />
        </div>
        {actionLabel ? (
          <span
            className="shrink-0 px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap border border-white/10"
            style={{ background: tone.pillBg, color: tone.surface }}
          >
            {actionLabel}
          </span>
        ) : null}
      </div>
      <div className="border-t border-white/10" />
      <div className="px-0">
        <ValueChangeBlock
          valueChangeDisplay={valueChange}
          intent={intent}
          embedded
          afterEditable={afterEditable}
          afterRawValue={valueAfterRaw}
          onAfterRawChange={onChangeValueAfterRaw}
          afterLabel={afterLabel}
        />
      </div>
    </div>
  );
}
